import { AdminCreatePortalPartnerDto } from '@routellers/types/dist/partners-portal/admin/admin-create-portal-partner.dto';
import { AdminPortalPartnerRO } from '@routellers/types/dist/partners-portal/admin/admin-portal-partner.ro';
import { AdminUpdatePortalMaterialOrderDto } from '@routellers/types/dist/partners-portal/admin/admin-update-portal-material-order.dto';
import { AdminUpdatePortalPartnerDto } from '@routellers/types/dist/partners-portal/admin/admin-update-portal-partner.dto';
import { BulkUpdatePortalPartnerStatusDto } from '@routellers/types/dist/partners-portal/admin/bulk-update-portal-partner-status.dto';
import { ParseVenuesByCityDto } from '@routellers/types/dist/partners-portal/admin/parse-venues-by-city.dto';
import { ParseVenuesByCityRO } from '@routellers/types/dist/partners-portal/admin/parse-venues-by-city.ro';
import { PortalMaterialOrderStatusEnum } from '@routellers/types/dist/partners-portal/enum/portal-material-order-status.enum';
import { PortalPartnerTypeEnum } from '@routellers/types/dist/partners-portal/enum/portal-partner-type.enum';
import { PortalMaterialOrderRO } from '@routellers/types/dist/partners-portal/portal-material-order.ro';
import { PortalPartnerRO } from '@routellers/types/dist/partners-portal/portal-partner.ro';
import { PortalPartnerStatsRO } from '@routellers/types/dist/partners-portal/portal-stats.ro';

import { ApiMethodDeclaration } from '..';

/** Админский API партнёрского портала (авторы квестов и площадки). */

const partners: ApiMethodDeclaration<
    { type?: PortalPartnerTypeEnum; cityId?: number } | undefined,
    AdminPortalPartnerRO[]
> = (params) => ({
    url: '/partners-portal/admin/partners',
    method: 'GET',
    params,
});

const createPartner: ApiMethodDeclaration<
    { data: AdminCreatePortalPartnerDto },
    AdminPortalPartnerRO & { temporaryPassword?: string }
> = ({ data }) => ({
    url: '/partners-portal/admin/partners',
    method: 'POST',
    data,
});

const updatePartner: ApiMethodDeclaration<
    { id: number; data: AdminUpdatePortalPartnerDto },
    AdminPortalPartnerRO
> = ({ id, data }) => ({
    url: `/partners-portal/admin/partners/${id}`,
    method: 'PATCH',
    data,
});

const bulkUpdateStatus: ApiMethodDeclaration<
    { data: BulkUpdatePortalPartnerStatusDto },
    { updated: number }
> = ({ data }) => ({
    url: '/partners-portal/admin/partners/bulk-status',
    method: 'POST',
    data,
});

const parseVenuesByCity: ApiMethodDeclaration<
    { data: ParseVenuesByCityDto },
    ParseVenuesByCityRO
> = ({ data }) => ({
    url: '/partners-portal/admin/venues/parse-city',
    method: 'POST',
    data,
});

const inviteQr: ApiMethodDeclaration<number, { inviteUrl: string; qrDataUrl: string }> = (id) => ({
    url: `/partners-portal/admin/partners/${id}/invite-qr`,
    method: 'GET',
});

/** Гостевой QR (буклеты): скан → скидка + атрибуция → страница города. */
const promoQr: ApiMethodDeclaration<number, { promoUrl: string; qrDataUrl: string }> = (id) => ({
    url: `/partners-portal/admin/partners/${id}/promo-qr`,
    method: 'GET',
});

const removePartner: ApiMethodDeclaration<number, { success: boolean }> = (id) => ({
    url: `/partners-portal/admin/partners/${id}`,
    method: 'DELETE',
});

const partnerStats: ApiMethodDeclaration<number, PortalPartnerStatsRO> = (id) => ({
    url: `/partners-portal/admin/partners/${id}/stats`,
    method: 'GET',
});

const materialOrders: ApiMethodDeclaration<
    { status?: PortalMaterialOrderStatusEnum } | undefined,
    Array<PortalMaterialOrderRO & { partner?: PortalPartnerRO }>
> = (params) => ({
    url: '/partners-portal/admin/material-orders',
    method: 'GET',
    params,
});

const updateMaterialOrder: ApiMethodDeclaration<
    { id: number; data: AdminUpdatePortalMaterialOrderDto },
    PortalMaterialOrderRO
> = ({ id, data }) => ({
    url: `/partners-portal/admin/material-orders/${id}`,
    method: 'PATCH',
    data,
});

export const partnersPortalAdminApiDeclaration = {
    partners,
    createPartner,
    updatePartner,
    bulkUpdateStatus,
    parseVenuesByCity,
    inviteQr,
    promoQr,
    removePartner,
    partnerStats,
    materialOrders,
    updateMaterialOrder,
};
